import {
  Dialog,
  DialogActionsWrapper,
} from "@/design-system/components/Dialog/Dialog";
import { Button } from "@/design-system/components/Button/Button";
import { User } from "@/components/users/types";

type DeleteUserModalProps = {
  open: boolean;
  user: User | null;
  onClose: () => void;
  onDelete: () => void;
};

export function DeleteUserModal({
  open,
  user,
  onClose,
  onDelete,
}: DeleteUserModalProps) {
  const userString = user ? user.email : "this user";

  return (
    <Dialog
      onOpenChange={(isOpen) => {
        if (!isOpen) onClose();
      }}
      open={open}
      title="Delete teammate"
    >
      <p className="text-sm">
        <span>
          Are you sure you want to delete <b>{userString}</b> from your account?
        </span>
      </p>
      <DialogActionsWrapper>
        <Button variant="ghost" onClick={onClose}>
          Close
        </Button>
        <Button variant="destructive" onClick={onDelete}>
          Delete user
        </Button>
      </DialogActionsWrapper>
    </Dialog>
  );
}
